import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { InputSubmitInterface } from '../../../types/interfaces/input.interface';

@Component({
  selector: 'app-input-submit',
  imports: [
    TranslatePipe,
  ],
  templateUrl: './input-submit.component.html',
  styleUrl: './input-submit.component.css'
})
export class InputSubmitComponent {
  @Input()
  public formData!: InputSubmitInterface;

  public isValid(): boolean {
    return this.formData.formGroup.valid;
  }
}
